import { trackPageview } from './analytics';
import { normalizePage } from './utils';
import { TAnalyticsMessagePayload } from '../../types';

export function pageviewSiteHandler([, eventParams]: TAnalyticsMessagePayload) {
  trackPageview(normalizePage(eventParams));
}
